import * as React from 'react';
import { connect } from 'react-redux';
import { Route, RouteComponentProps, Switch, withRouter } from "react-router-dom";

import * as conceptsActions from '../../actions/concepts';
import * as conceptsFeedbackActions from '../../actions/conceptsFeedback';
import * as fillInBlankConceptsFeedbackActions from '../../actions/fillInBlankConceptsFeedback';
import * as grammarActivitiesActions from '../../actions/grammarActivities';
import * as questionsActions from '../../actions/questions';
import * as fillInBlankQuestionsActions from '../../actions/fillInBlankQuestions'
import { ConceptDetail, Concepts, StaffOnlyWrapper, TabLink, ConceptsFeedback, } from '../../../Shared';
import AdminActivity from './adminActivity';
import ConceptFeedback from '../conceptsFeedback/conceptFeedback';
import FillInBlankConceptFeedback from '../conceptsFeedback/fillInBlankConceptFeedback';
import FillInBlankActivity from '../fillInBlankActivities/fillInBlankActivity';
import FillInBlankActivities from '../fillInBlankActivities/fillInBlankActivities';
import FillInBlankQuestionManager from '../fillInBlankActivities/fillInBlankQuestionManager';
import Lesson from '../lessons/lesson';
import Lessons from '../lessons/lessons';
import Question from '../questions/question';
import Questions from '../questions/questions';

interface PathParamsType {
  [key: string]: string,
}

class AdminContainer extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.props.dispatch(fillInBlankQuestionsActions.startListeningToQuestions());
    this.props.dispatch(questionsActions.startListeningToQuestions());
    this.props.dispatch(grammarActivitiesActions.startListeningToActivities());
    this.props.dispatch(conceptsActions.startListeningToConcepts());
    this.props.dispatch(conceptsFeedbackActions.startListeningToConceptsFeedback());
    this.props.dispatch(fillInBlankConceptsFeedbackActions.startListeningToConceptsFeedback());
  }

  renderMainSidebar = () => {
    return (
      <aside className="menu" style={{ minWidth: 220, borderRight: '1px solid #e3e3e3', padding: 15, paddingLeft: 0, minHeight: '100vh' }}>
        <p className="menu-label">
          Sentence-Level Grammar
        </p>
        <ul className="menu-list">
          <TabLink to="/admin/lessons">Sentence-Level Grammar Activities</TabLink>
          <TabLink to="/admin/questions">Sentence-Level Grammar Questions</TabLink>
          <TabLink to="/admin/concepts">Sentence-Level Grammar Concepts</TabLink>
          <TabLink to="/admin/concepts_feedback">Sentence-Level Grammar Concept Feedback</TabLink>
        </ul>
        <p className="menu-label">
          Fill in the Blank
        </p>
        <ul className="menu-list">
          <TabLink to="/admin/fitb_activities">FITB Activities</TabLink>
          <TabLink to="/admin/fitb_concepts">FITB Concepts</TabLink>
          <TabLink to="/admin/fitb_concepts_feedback">FITB Concept Feedback</TabLink>
        </ul>
      </aside>
    );
  }

  render() {
    const { concepts, dispatch, questions, fillInBlank, conceptsFeedback, fillInBlankConceptsFeedback, children, } = this.props;

    const content = (
      <div style={{ display: 'flex', backgroundColor: "white" }}>
        <Switch>
          <Route component={AdminActivity} path="/admin/activity-view" />
          <Route
            path="/admin"
            render={() => (
              <section className="section is-fullheight" style={{ display: 'flex', flexDirection: 'row', paddingTop: 0, paddingBottom: 0, }}>
                {this.renderMainSidebar()}
                {children && <div className="admin-container">{children}</div>}
              </section>
            )}
          />
        </Switch>
        <Switch>
          <Route component={Lesson} path="/admin/lessons/:lessonID" />
          <Route component={Lessons} path="/admin/lessons" />
          <Route component={Question} path="/admin/questions/:questionID" />
          <Route component={Questions} path="/admin/questions" />
          <Route
            path="/admin/concepts/:conceptID"
            render={({ match }) => (
              <ConceptDetail
                concepts={concepts}
                includeDeleteButton={false}
                includeQuestionForm={true}
                isGrammarQuestion={true}
                match={match}
                onSubmitNewQuestion={(question: any) => dispatch(questionsActions.submitNewQuestion(question))}
                questions={questions}
                renderLoading={() => <div>Loading...</div>}
                returnLink="/admin/concepts"
                useConceptUid={true}
              />
            )}
          />
          <Route
            path="/admin/concepts"
            render={() => (
              <Concepts
                concepts={concepts}
                questions={questions.data}
              />
            )}
          />
          <Route component={ConceptFeedback} path="/admin/concepts_feedback/:conceptFeedbackID" />
          <Route
            path="/admin/concepts_feedback"
            render={() => (
              <ConceptsFeedback
                concepts={concepts}
                conceptsFeedback={conceptsFeedback}
              />
            )}
          />
          <Route component={FillInBlankActivity} path="/admin/fitb_activities/:lessonID" />
          <Route component={FillInBlankActivities} path="/admin/fitb_activities" />
          <Route component={FillInBlankQuestionManager} path="/admin/fill-in-the-blanks/:questionID" />
          <Route
            path="/admin/fitb_concepts/:conceptID"
            render={({ match }) => (
              <ConceptDetail
                concepts={concepts}
                fillInBlank={fillInBlank}
                match={match}
                renderLoading={() => <div>Loading...</div>}
                returnLink="/admin/fitb_concepts"
              />
            )}
          />
          <Route
            path="/admin/fitb_concepts"
            render={() => (
              <Concepts
                concepts={concepts}
                fillInTheBlank={true}
                questions={fillInBlank.data}
              />
            )}
          />
          <Route component={FillInBlankConceptFeedback} path="/admin/fitb_concepts_feedback/:conceptFeedbackID" />
          <Route
            path="/admin/fitb_concepts_feedback"
            render={() => (
              <ConceptsFeedback
                concepts={concepts}
                conceptsFeedback={fillInBlankConceptsFeedback}
                fillInTheBlank={true}
              />
            )}
          />
        </Switch>
      </div>
    );

    return <StaffOnlyWrapper>{content}</StaffOnlyWrapper>;
  }
}

function select(state: any) {
  return {
    concepts: state.concepts,
    questions: state.questions,
    fillInBlank: state.fillInBlank,
    conceptsFeedback: state.conceptsFeedback,
    fillInBlankConceptsFeedback: state.fillInBlankConceptsFeedback,
  };
}

function mergeProps(stateProps: Object, dispatchProps: Object, ownProps: Object) {
  return {...ownProps, ...stateProps, ...dispatchProps}
}

export default withRouter(connect(select, dispatch => ({dispatch}), mergeProps)(AdminContainer));
